import axios from "axios";
import Cookies from "js-cookie";

import { API_BASE_URL } from "./apiBaseUrl";

const axiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/`,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const clearAuthData = () => {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("auth_role");
  Cookies.remove("user_id");
  Cookies.remove("student_id");
  Cookies.remove("email");
  Cookies.remove("first_name");
  Cookies.remove("last_name");
  localStorage.removeItem("isAuthenticated");
};

const redirectToLogin = (role?: string) => {
  const query = role === "student" ? "?role=student" : "?role=teacher";
  window.location.href = `/login${query}`;
};

axiosInstance.interceptors.response.use(
  (response) => {
    if (["post", "put", "patch", "delete"].includes(response.config.method || "")) {
      window.dispatchEvent(new Event("storage-usage-changed"));
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 413 && error.response?.data?.code === "storage_quota_exceeded") {
      window.dispatchEvent(new CustomEvent("storage-quota-exceeded", { detail: error.response.data }));
    }

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const role = Cookies.get("auth_role");
      const refreshToken = Cookies.get("refresh_token");
      if (!refreshToken) {
        clearAuthData();
        redirectToLogin(role);
        return Promise.reject(error);
      }

      try {
        const refreshEndpoint = role === "student"
          ? `${API_BASE_URL}/student-auth/token/refresh/`
          : `${API_BASE_URL}/auth/token/refresh/`;
        const { data } = await axios.post(refreshEndpoint, { refresh: refreshToken });
        Cookies.set("access_token", data.access, {
          sameSite: "Lax",
          secure: window.location.protocol === "https:",
        });
        originalRequest.headers.Authorization = `Bearer ${data.access}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        clearAuthData();
        redirectToLogin(role);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
